import { Navigate, useParams } from "react-router-dom";

import { ROUTES } from "@/app/router";
import { EditSessionActions } from "@/features/coaching/components";
import { EditSessionContextProvider } from "@/features/coaching/context";
import { useAdminSession } from "@/features/coaching/hooks";
import { AdminScreenContentLayout } from "@/features/coaching/layouts";
import {
  EditSessionForm,
  EditSessionHeader,
} from "@/features/coaching/sections";
import { LogoLoader } from "@/shared/components";

export const EditSession = () => {
  const { sessionId } = useParams();

  const {
    data: session,
    isLoading,
    isError,
    isSuccess,
  } = useAdminSession(Number(sessionId));

  if (!sessionId || isError) {
    return <Navigate to={ROUTES.COACHING.OVERVIEW} />;
  }

  return (
    <AdminScreenContentLayout>
      <LogoLoader show={isLoading} withOverlay />

      {isSuccess && (
        <EditSessionContextProvider session={session}>
          <EditSessionHeader />

          <div className="grow">
            <EditSessionForm />
          </div>

          <EditSessionActions />
        </EditSessionContextProvider>
      )}
    </AdminScreenContentLayout>
  );
};
